module.exports = __webpack_public_path__ + "img/DE00423.cddb090e.png";